import React, {Component} from 'react'
import WeekOverview from './WeekOverview'
import WeekLinks from '../tags/WeekLinks'
import SystemLinks from './SystemLinks'

class Sidebar extends Component {
  render() {
    return (
      <aside className='sidebar'>
        <WeekOverview/>
        <WeekLinks/>
        <SystemLinks/>
      </aside>
    )
  }
}

export default Sidebar
